import { motion } from "framer-motion";
import { ScanFace, Activity, Eye, Users, Brain, FileSpreadsheet, ShieldCheck, AudioLines } from "lucide-react";
import { RevealOnScroll } from "./RevealText";
import { featureIcons, featureNums } from "../data/staticData";
import { useLanguage } from "../i18n/LanguageContext";

const icons = { ScanFace, Activity, Eye, Users, Brain, FileSpreadsheet, ShieldCheck, AudioLines };
const ids = ["emotions", "trust-stress", "deception", "demographics", "portrait", "reports", "privacy", "voice"];

export function Features() {
  const { t } = useLanguage();
  return (
    <section id="features" className="relative py-24 lg:py-32 bg-[#050505]" data-testid="features-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <RevealOnScroll className="max-w-2xl mb-16">
          <span className="font-mono-data text-xs text-[#00F0FF]">/ {t.nav.features.toUpperCase()}</span>
          <h2 className="mt-4 font-display font-bold text-4xl sm:text-5xl text-white tracking-tighter">
            {t.features.title}
          </h2>
          <p className="mt-4 text-zinc-400 text-base sm:text-lg">{t.features.subtitle}</p>
        </RevealOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-white/10">
          {t.features.items.map((f, i) => {
            const Icon = icons[featureIcons[i]];
            return (
              <RevealOnScroll key={ids[i]} delay={(i % 3) * 0.08}>
                <div
                  className="group relative h-full border-r border-b border-white/10 p-8 hover:bg-white/[0.02] transition-colors duration-300"
                  data-testid={`feature-card-${ids[i]}`}
                >
                  <span className="font-display font-black text-5xl text-white/[0.06] absolute top-4 right-6 select-none">
                    {featureNums[i]}
                  </span>
                  <Icon className="w-8 h-8 text-[#00F0FF] mb-6 group-hover:glow-cyan transition-all duration-300" strokeWidth={1.5} />
                  <h3 className="font-display font-semibold text-lg text-white leading-snug">{f.title}</h3>
                  <p className="mt-3 text-sm text-zinc-500 leading-relaxed">{f.description}</p>
                </div>
              </RevealOnScroll>
            );
          })}
        </div>
      </div>
    </section>
  );
}
